import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import logo from "../../assets/img/logo.svg";
import avatar from "../../assets/img/avatar.png";
import messageIconHeader from "../../assets/icons/messageIconHeader.svg";

// import { getImage } from "../../utilities/storageOperations/downloadURL";
import { connect } from "react-redux";

import "./Header.css";
import Sidebar from "../../pages/Credentialing/components/Sidebar";
import Nodification_Icon from "../../assets/icons/Nodification_Icon.png";

import {
  ConsoleSqlOutlined,
  LockOutlined,
  StarFilled,
  StarOutlined,
} from "@ant-design/icons";
// import { MdEmail } from "react-icons/md";
// import { IoMdArrowDropdown } from "react-icons/io";
import { MdOutlineMessage } from "react-icons/md";
// import { Mdoutlineme }
import { BsBell } from "react-icons/bs";
import { IoIosStar } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";

import {
  Modal,
  Tooltip,
  Popover,
  Badge,
  Drawer,
  Layout,
  Menu,
  Dropdown,
  Row,
  Col,
  Rate,
  Spin,
} from "antd";

import ProfileHeader from "./components/ProfileHeader";
// import ProfileAvatar from "../ProfileAvatar";
import history from "../../routes/history";
// import SearchGigs from "../pages/SearchGigs/SearchGigs";

import { useLocation, useRouteMatch, Link } from "react-router-dom";
// import { sectionHeader } from "@aws-amplify/ui";
import {
  checkEmailFlow,
  fetchUserProfile,
  isModalVisibleAuth,
  signUpLoginUpdate,
  fetchInboxMessages,
  fetchMessagesCounts,
  fetchNotification,
  wizardFinished,
  getAbsAccounts,
  getConversationCountInit,
  fetchUserTagRequest
} from "../../redux/actions";
import { getCookie, setCookie, getPictureUrl, getCompanyName, isHC, isNonHC } from "../../shared/helpers";
import { canAccessProjectsPlan, isSkillRadarUser } from "../../shared/billing";
import SearchBar from "../../pages/SearchSkillListing/SearchBar";
// import ManageBidsMenu from "./components/ManageBidsMenu";
import Notifications from "../Notification/Notifications";
import { DefaultRating } from "../../assets/helpers";
// import EmailVerification from "../EmailVerification/EmailVerification";
import poweredByWeb from "../../assets/icons/poweredByWeb.svg";
import poweredByMob from "../../assets/icons/poweredByMob.svg";
import SGMob from "../../assets/icons/SGMob.svg";
import NotificationDropDown from "./components/NotificationDropDown";
import { PLAIN_HEADER_ROUTES } from "../../shared/constants";

const Header = (props) => {
  const dispatch = useDispatch();
  const { path, url } = useRouteMatch();
  const Token = getCookie("token");
  const finishProfile = getCookie("finishProfile");

  const initialPaths = useLocation().pathname.split("/")[1];
  const [route, setRoute] = useState(initialPaths);
  const initialPath = window.name;
  const subrout = useLocation().pathname.split("/")[2];
  const [sbarVisible, setsbarVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const pathParts = window?.location?.pathname?.split("/") || [];
  const currentRoute = window?.location?.pathname === "/" ? "/" : pathParts[2] || pathParts[1];


  // const [profilePic, setProfilePic] = React.useState();
  const [proImg, setProImg] = useState(null);
  const [userName, setUserName] = useState("");
  const [profession, setProfession] = useState("");
  const [unRead, setUnread] = useState(false);
  const [finishProf, setFinishProf] = useState(false);
  const [starsR, setStarsR] = useState(DefaultRating);
  let userProfile = localStorage.getItem("userProfile");
  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));
  const truncatedName  = getCompanyName(props?.firstUser?.profile);
  const companyName = truncatedName?.length > 17 ? truncatedName?.substring(0, 17) + '...' : truncatedName;
  const employerDetails = userProfile1?.PrivateEmployerDashboard;
  const imageURL = JSON.parse(localStorage.getItem("profilePicture"));
  const [loggedInSearchBar, setloggedInSearchBar] = useState(false);
  const profile = useSelector((state) => state.profileReducer.user);
  const canShowPrivateTalent =
    isSkillRadarUser(profile) || isSkillRadarUser(userProfile1);
  const { ABS } = useSelector((state) => state.profileReducer);
  const signUpLogin = useSelector((state) => state.authReducer.signUpLogin);
  const notification = useSelector(
    (state) => state.fetchNotificationReducer.notification
  );
  const notificationUnreadCount = useSelector(
    (state) => state.fetchNotificationReducer.notificationUnreadCount
  );
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const canShowProjects = canAccessProjectsPlan(creditsBalance);
   useEffect(() => {
      dispatch(getConversationCountInit());
  }, [])

  const conversationUnreadCount = useSelector(
    (state) => state.messagesReducer.conversationUnreadCount
  );

  const resp = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.resp
  );
  const jobdetails = useSelector(
    (state) => state.getJobDetailReducer.jobdetails
  );

  const urlCheck = useLocation();

  const isNotificationCheck = localStorage.getItem("isNotificationCheck");
  const [isNotification, setisNotification] = useState(
    isNotificationCheck === "true" ? true : ""
  );
  const [isCountVisible, setIsCountVisible] = useState({
    message: true,
    notification: true,
  });

    useEffect(() => {
      setStarsR(
        profile.profile?.Rating === 0 ||
          profile.profile?.Rating === null ||
          profile.profile?.Rating === undefined
          ? DefaultRating
          : parseFloat(profile.profile?.Rating)
      );
    }, [profile.profile]);
  

  // const [isModalVisibleAuth, setIsModalVisibleAuth] = useState(false);
  const { isModalVisibleAuth, setIsModalVisibleAuth } = props;
  const { authToken } = props;

  const onClickLogo = () => {
    if (finishProf) history.push("/employerdashboard");
  };

  const getWebLogo = () => {
    return (
      <Row
        style={{ display: "flex", padding: "6px 0px", minWidth: "130px" }}
        align="flex-start"
        gutter={[{ md: 5, lg: 6, xl: 15, xxl: 20 }, 0]}
        wrap={false}
      >
        <Col
          span={8}
          style={{
            cursor: "pointer",
            maxWidth: "108px",
            minWidth: "50px",
            alignSelf: "center",
            paddingLeft: "0px !important",
            paddingRight: "0px !important",
          }}
        >
          <a
            href={employerDetails?.webUrl || "https://www.shi.com"}
            target="_blank"
            rel="nonreferrer noreferrer"
          >
            <img src={getPictureUrl(employerDetails?.logo?.desktop || employerDetails?.logo )} alt="emp" style={{width:'100%',height:'2.25rem'}} />
          </a>
        </Col>
        <Col span={1} style={{ borderRight: "2px gray solid" }}>
          {" "}
        </Col>
        <Col span={14}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "100%",
              padding: "0",
              paddingTop: "4px",
            }}
          >
            <img
              src={poweredByWeb}
              alt="poweredBy"
              style={{ marginRight: "4px" }}
            />
            <img src={logo} alt="logo" className="logo" onClick={onClickLogo} />
          </div>
        </Col>
      </Row>
    );
  };

  const getMobileLogo = () => {
    return (
      <Row
        align="center"
        gutter={[{ xs: 4, sm: 8, md: 8 }, 0]}
        wrap={false}
        justify={"center"}
        style={{ padding: "4px 0px" }}
      >
        <Col
          style={{ maxWidth: "70px", minWidth: "40px", alignSelf: "center" }}
        >
          <a
            href={employerDetails?.webUrl}
            target="_blank"
            rel="nonreferrer noreferrer"
            style={{ alignSelf: "center" }}
          >
            <img
              src={getPictureUrl( employerDetails?.logo?.desktop || employerDetails?.logo )}
              alt="emp"
              style={{
                width: window.innerWidth < 400 ? "60px" : "70px",
                margin: "0px",
                height:'2rem'
              }}
            />
          </a>
        </Col>
        <Col style={{ borderRight: "2px gray solid" }}> </Col>
        <Col>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "100%",
              padding: "0",
              paddingTop: "5px",
              paddingLeft: "4px",
            }}
          >
            <img
              src={poweredByMob}
              alt="poweredBy"
              style={{
                width: window.innerWidth < 400 ? "31px" : "41px",
                marginRight: "2px",
              }}
            />
            <img
              src={SGMob}
              alt="logo"
              onClick={onClickLogo}
              style={{
                width: window.innerWidth < 400 ? "72px" : "82px",
                marginLeft: "2px",
              }}
            />
          </div>
        </Col>
      </Row>
    );
  };

  const showModal = () => {
    setIsModalVisibleAuth(true);
  };

  const modalCancel = () => {
    setIsModalVisibleAuth(false);
  };

  useEffect(() => {
    if (finishProfile === "true") {
      setFinishProf(true);
      setShowSearchBar(true);
      dispatch(wizardFinished());
      setShowSearchBar(true);
    }
  }, [finishProfile, jobdetails]);

  const [check, setCheck] = useState("");
  const [header, setHeader] = useState("");
  let headerType = "";

  const [drawerState, setDrawerState] = useState({
    visible: false,
    placement: "left",
  });
  const [drawerStates, setDrawerStates] = useState({
    visibles: false,
    placements: "left",
  });
  const [sgLogo, setSgLogo] = useState(false);
  const [dropVisible, setDropVisible] = useState(false);
  const [billingLoading, setBillingLoading] = useState(false);
  const [dropDisable, setDropDisable] = useState(false);
  // const [dropVisibleBids, setDropVisibleBids] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [dropVisibleNotifications, setDropVisibleNotifications] =
    useState(false);

  useEffect(() => {
    if (authToken != null) {
      // dispatch(getAbsAccounts());
      dispatch(fetchUserTagRequest());
      // dispatch(fetchMessagesCounts("all_bids"));
      dispatch(
        fetchNotification({
          currentPage: currentPage,
          pageSize: pageSize,
        })
      );
      dispatch(
        fetchInboxMessages("all_bids", "all_conversations", "null", 1, 5)
      );
    }
  }, [authToken]);

  const closeNotificationModal = () => {
    setNotificationModal(false);
  };
  const handleVisibleChange = (visible) => {
    setDropVisible(visible);
  };

  const handleVisibleNotifications = (visible) => {
    setDropVisibleNotifications(visible);
  };
  const hideDrop = () => {
    setDropVisible(false);
  };

  //redirect to login page if token/cookies are removed
  useEffect(() => {
    if (Token?.length > 0) {
      return;
    } else if (Token === null && authToken?.length > 0) {
      window.location.replace("/");
    }
  }, [Token]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  // useEffect(async () => {
  //   let profilePic = "";
  //   if (profile?.profile?.PictureUrl) {
  //     profilePic = await getImage(profile.profile.PictureUrl);
  //   }
  //   setProfilePic(profilePic);
  // }, [profile]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowDimensions.width < 769) {
      setSgLogo(true);
    } else setSgLogo(false);
  }, [windowDimensions]);

  const clicked = () => {
    setsbarVisible(!sbarVisible);
  };

  const signInUser = () => {
    if (windowDimensions.width < 769) {
      history.push("/login");
      setDrawerStates({ visibles: false });
    } else {
      showModal();
    }
    dispatch(checkEmailFlow(false));
    dispatch(signUpLoginUpdate(false));
  };

  const joinUser = () => {
    if (windowDimensions.width < 769) {
      history.push("/login");
      setDrawerStates({ visibles: false });
    } else {
      showModal();
    }
    // dispatch(checkEmailFlow(false));
    dispatch(signUpLoginUpdate(true));
  };

  const getPath = () => {
    try {
      return window?.location?.pathname?.split("/")[2];
    } catch (error) {
      return initialPaths;
    }
  };

  useEffect(() => {
    if (
      !window.location.pathname?.includes("/query") &&
      !window.location.pathname?.includes("/profiledetail")
    ) {
      localStorage.removeItem("SelectedSkillsSearch");
    }
    if (
      !window.location.pathname?.includes("/candidatemarketing") &&
      !window.location.pathname?.includes("/profiledetail")
    ) {
      localStorage.removeItem("SelectedSkills");
    }

    setRoute(getPath());
  }, [window.location.pathname, urlCheck]);

  useEffect(() => {
    modalCancel();
  }, [urlCheck]);

  let headerContent = (
    <span>
      <LockOutlined /> Secured connection
    </span>
  );

  const showDrawer = () => {
    setDrawerState({ visible: true });
  };

  const onClose = () => {
    setDrawerState({ visible: false });
  };

  const showDrawers = () => {
    setDrawerStates({ visibles: true });
  };

  const onCloses = () => {
    setDrawerStates({ visibles: false });
  };

  useEffect(() => {
    var obj = JSON.parse(props?.userProfile);
    if (obj?.profile?.PictureUrl) {
      setProImg(obj.profile.PictureUrl);
    }

    // Displayed User Name
    if (props.profile?.length > 10) {
      const name = obj?.name.split(" ")[0];
      setUserName(name);
    } else {
      setUserName(obj?.profile?.FirstName);
    }

    const pro = userProfile1?.Professions?.ProfessionCode;
    if (isNonHC(pro)) {
      setProfession("IT");
    } else if (pro === "FL") {
      setProfession("IT Freelancer");
    } else if (isHC(pro)){
      setProfession("HC");
    } else {
      setProfession("Healthcare");
    }
  }, [props.profile]);

  const openMessages = () => {
    history.push({
      pathname: "/messages",
      state: {
        user: props.profile,
      },
    });
  };
  localStorage.setItem("userName", props.profile);

  const homepage = () => {
    // history.push("/");
    history.push("https://skillgigs.com/");
    // window.location.replace('https://skillgigs.com/');
    setDrawerStates({ visibles: false });
  };

  const notificationHandler = (Icon, isMobileSwitch) => {
    // setShowSearchBar(false);
    history.push({
      pathname: "/notification",
      state: {
        fromNotification: true,
        Icon: Icon,
        fromMobileIsTabSwitch: isMobileSwitch
      },
    });
  };
  const commonHeader = (
    <div
      className="wizard-head-dashboard"
      style={{ color: "white", bgColor: "white" }}
    >
      <div className="bars" onClick={showDrawer}>
        <GiHamburgerMenu />
      </div>
      {/*<div style={{ flex: 1 }}></div>*/}
      {windowDimensions.width >= 769 && <SearchBar/>}
      {/*<div style={{ flex: 1 }}></div>*/}

      {windowDimensions.width < 769 &&
        (getPictureUrl(employerDetails?.logo?.desktop || employerDetails?.logo) &&
        userProfile1?.IsPrivateEmployer ? (
          getMobileLogo()
        ) : (
          <img src={logo} alt="logo" className="logo" onClick={onClickLogo} />
        ))}

      {(windowDimensions.width > 1200 && userProfile1?.IsPrivateEmployer) ||
      !userProfile1?.IsPrivateEmployer ? (
        <div className="loginButton theAlign">
          <div className="inbox-hover">
            {/* <Badge dot={notificationUnreadCount > 0 ? true : false}>
              <Dropdown
                overlayClassName="notification-dropdown"
                overlay={
                  <Notifications
                    visible={setDropVisibleNotifications}
                    closeModal={setDropVisibleNotifications}
                  />
                }
                onOpenChange={() =>
                  handleVisibleNotifications(!dropVisibleNotifications)
                }
                placement="bottomRight"
                trigger={["click"]}
                open={dropVisibleNotifications}
                arrow
              >
                <div className="inbox">Messages</div>
              </Dropdown>
            </Badge> */}
          </div>
          <Link to={"/employerdashboard"} className="skillListingButton">
            <div
              className="skillListing-btn"
              onClick={() => history.push("/employerdashboard")}
            >
              Dashboard
            </div>
          </Link>
          {canShowProjects && (
            <Link to={"/manage-projects"} className="skillListingButton">
              <div
                className="skillListing-btn"
                onClick={() => history.push("/manage-projects")}
              >
                Projects
              </div>
            </Link>
          )}
          {canShowPrivateTalent && (
            <Link to="/internal" className="skillListingButton">
              <div
                className="skillListing-btn"
                onClick={() => history.push("/internal")}
              >
                Private Talent
              </div>
            </Link>
          )}
          <Link to={"/joblisting"} className="skillListingButton">
            <div
              className="skillListing-btn"
              onClick={() =>
                history.push({
                  pathname: "/joblisting",
                  state: { param: resp?.jobs },
                })
              }
            >
              Manage Jobs
            </div>
          </Link>
          <Link to={"/create-job"} className="skillListingButton">
            <div
              className="skillListing-btn"
              onClick={() => history.push("/create-job")}
            >
              Post a Job
            </div>
          </Link>
        </div>
      ) : null}

      {<NotificationDropDown windowDimensions={windowDimensions}/>}
      {windowDimensions.width < 769 && (
        <div className="mobileDefaultButtons">
          <div className="bellIcon">
          <Badge
            offset={[5, 4]}
            size="small"
            count={isCountVisible.notification ? notificationUnreadCount : 0}
            color="#fbdf50"
          >
            <span
              onClick={() => notificationHandler("bell",true)}
            >
            <img
              src={Nodification_Icon}
              alt=""
            />
            </span>
          </Badge>
          </div>
          <div className="messageIconHeader">
          <Badge
            offset={[0, 3]}
            size="small"
            count={isCountVisible?.message ? conversationUnreadCount : 0}
            color="#db2828"
          >
            <span
              onClick={() => notificationHandler("message",false)}
            >
            <img
              src={messageIconHeader}
              alt=""
            />
            </span>
          </Badge>
          </div>
        </div>
      )}
    </div>
  );

  useEffect(() => {
    if (initialPath === "credentialing") {
      setCheck(subrout);
    } else if (initialPath === "login") {
      setCheck(initialPath);
    } else if (initialPath === "search") {
      setCheck(initialPath);
    } else if (initialPath === "terms") {
      setCheck(initialPath);
    } else if (initialPath === "details") {
      setCheck(initialPath);
    } else if (initialPath === "forgot") {
      setCheck(initialPath);
    } else if (initialPath === "") {
      setCheck(initialPath);
    } else if (initialPath === "employerdashboard") {
      setCheck(initialPath);
    } else {
      setCheck(props.stage);
    }
    if (headerType === "default") {
      setHeader("black-header");
    }

    // dropdown disable state on pages
    if (
      initialPath === "talentemployer" ||
      initialPath === "employerprofession" ||
      initialPath === "personaldetails" ||
      initialPath === "companydetails" ||
      initialPath === "allset"
    ) {
      setDropDisable(true);
    } else setDropDisable(false);
  }, [initialPath, props.stage]);

  if (authToken != null) {
    headerContent = (
      <React.Fragment>
        <div className="wizard-head-dashboard" style={{ color: "white" }}>
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="Avatar">
          <div className="Avat">{userName?.charAt(0)}</div>
        </div>
      </React.Fragment>
    );
  }

  switch (initialPath) {
    case "talentemployer":
    case "employerprofession":
    case "personaldetails":
    case "companydetails":
    case "allset":
      headerContent = (
        <>
          {windowDimensions.width < 769 && (
            <div
              className="wizard-head-dashboard-guest"
              style={{ color: "white" }}
            >
              <img src={logo} alt="logo" className="logo-guest" />
            </div>
          )}
        </>
      );
      break;
    // case "conversations":
    //   return setUnread(true);

    default:
      headerType = "default";
      if (!authToken) {
        headerContent = (
          <div className="wizard-head-dashboard" style={{ color: "white" }}>
            <div className="bars" onClick={showDrawers}>
              <GiHamburgerMenu />
            </div>
            <img
              src={logo}
              alt="logo"
              className="logo"
              onClick={() => {
                history.push("/employerdashboard");
              }}
            />
            {windowDimensions.width >= 769 && <SearchBar />}
            <section className="logoutButtonsHeader">
              <div
                className="btn_home"
                // onClick={homepage}
              >
                <a href="https://skillgigs.com/">Home</a>
              </div>
              <div className="btn_sign_In" onClick={signInUser}>
                Sign in
              </div>
              <div className="joinNowBtn">
                <div className="clickSkillListing" onClick={joinUser}>
                  Join
                </div>
              </div>
            </section>
          </div>
        );
      } else {
        headerContent = commonHeader;
      }
      break;
  }

  const { placement, visible } = drawerState;
  const { placements, visibles } = drawerStates;
  const titleDrawer = (
    <div className="title-drawer-mobileView">
      {/* <Badge dot={true} status={"success" || "default"}> */}
      {/* <div className="Avat">{userName?.charAt(0)}</div> */}
      {imageURL && imageURL?.split("/")?.pop() !== "no-pic.png" ? (
        <div className="Avat2">
          <img
            src={`${process.env.REACT_APP_S3_URL}${
              imageURL?.charAt(0) !== "/" ? "/" : ""
            }${imageURL}`}
            alt=""
            style={{
              objectFit: "fill",
              overflow: "hidden",
            }}
          />
        </div>
      ) : (
        <div className="profile theAlign">
          <div className="Avat">
          { getCompanyName(props?.firstUser?.profile) ? getCompanyName(props?.firstUser?.profile).charAt(0) : "C"}
          </div>
        </div>
      )}
      {/* </Badge> */}
      <div className="title-data">
        <div className="username-header">
          <span>{companyName}</span>
        </div>
        <div className="use-rating-menu">
          <span
            className="professional-code"
          >
            {" "}
            {profession}
          </span>
          <div className="DashBoard-Profile-user-rating-section-menu">
            <div className="DashBoard-Profile-user-rating-star-menu">
              <Rate count={1} size="small" disabled defaultValue={1} style={{paddingBottom : '2px'}}/>
            </div>
            <div className="DashBoard-Profile-user-rating-number-menu">
            {starsR || DefaultRating}{" "}
              out of 5
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const titleDrawerlogin = (
    <div>
      <div className="DrowerHeader">
        <img src={avatar} />
        <div>
          <div className="Guestuserfont">Guest user</div>
          <div className="welcomefont">Welcome to SkillGigs</div>
        </div>
      </div>
    </div>
  );

  if (
    PLAIN_HEADER_ROUTES.includes(window?.location?.pathname?.split("/")?.[2])
  ) {
    return (
      <div className={`header h-60 bg-black  `}>
        <a href="https://www.skillgigs.com" className="new-page-logo">
          <img src={logo} alt="logo" className="logo" />
        </a>
      </div>
    );
  }


  if (["/", "login", "signin", "signup", "forgot", "reset-password"].includes(currentRoute)) {
    return <Fragment></Fragment>;
  }

  return (
    <React.Fragment>
      {billingLoading && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255,255,255,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}>
          <Spin size="large" />
        </div>
      )}
      {/* {(!userProfile1?.verification?.email && finishProf) && <EmailVerification/> } */}
      {sbarVisible && (
        <Sidebar changeStage={props.changeStage} hide={clicked} />
      )}


      {/*Notification Modal */}
      <Modal
        bodyStyle={{ padding: 0 }}
        width="24.37rem"
        open={notificationModal}
        closable={false}
        footer={null}
        style={{ top: 80, left: 220, padding: 0 }}
        onCancel={closeNotificationModal}
        maskClosable={true}
        // centered={true}
      >
        <Notifications />
      </Modal>

      <div
        className={`header ${headerType === "default" && "black-header"}`}
        aria-details={urlCheck.pathname === "/filecontainer" && "noHeader"}
        // aria-details={(!userProfile1?.verification?.email && finishProf) && "extra-top"}
        // style={{
        //  top: (!userProfile1?.verification?.email && finishProf) && '4.56rem'
        // }}
      >
        {!sgLogo ? (
          getPictureUrl(employerDetails?.logo?.desktop || employerDetails?.logo) &&
          userProfile1?.IsPrivateEmployer ? (
            getWebLogo()
          ) : (
            <div>
              <img src={logo} alt="logo" className="logo" onClick={()=> history.push('/')}/>
            </div>
          )
        ) : (
          //     finishProf ?
          //         (
          //           <Link to="/employerdashboard">
          //             <div>
          //               <img
          //                 src={logo}
          //                 alt="logo"
          //                 className="logo"
          //                 onClick={() => {
          //                     history.push("/employerdashboard");
          //                   }}
          //               />
          //             </div>
          //           </Link>
          //         )
          //         : (
          //           <div>
          //             <img
          //               src={logo}
          //               alt="logo"
          //               className="logo"
          //             />
          //           </div>
          // )
          <Drawer
            title={titleDrawer}
            placement="left"
            closable={false}
            onClose={onClose}
            open={visible}
            className="burgerMenuDrawerMobileView"
            width="90.5vw"
            // key={placement}
          >
            <ProfileHeader
              changeStage={props.changeStage}
              hide={setDrawerState}
              visible={visible}
            />
          </Drawer>
        )}
        {!authToken ? (
          <div className="wizard-head-dashboard" style={{ color: "white" }}>
            <div className="bars" onClick={showDrawers}>
              <GiHamburgerMenu />
            </div>
            <div className="without-auth-logo">
              <img
                src={logo}
                alt="logo"
                className="logo"
                onClick={() => {
                  history.push("/employerdashboard");
                }}
              />
            </div>
            {windowDimensions.width >= 769 && <SearchBar />}
            <section className="logoutButtonsHeader">
              <div
                className="btn_home"
                // onClick={homepage}
              >
                <a href="https://skillgigs.com/">Home</a>
              </div>
              <div
                className="btn_sign_In btn_sign_In_effect"
                onClick={signInUser}
              >
                <div className="Sign-in-hover">Sign in</div>
              </div>
              <div className="joinNowBtn">
                <div className="clickSkillListing" onClick={joinUser}>
                  Join
                </div>
              </div>
            </section>
          </div>
        ) : !finishProf ? (
          windowDimensions.width < 769 && (
            <div
              className="wizard-head-dashboard-guest"
              style={{ color: "white" }}
            >
              {/* {setShowSearchBar(false)} */}
              <img src={logo} alt="logo" className="logo-guest" />
            </div>
          )
        ) : (
          finishProf && commonHeader
        )}

        {authToken && window.innerWidth >= 769 && (
          <Dropdown
            overlayClassName={
              !userProfile1?.verification?.email && finishProf
                ? "header-dropdown"
                : "header-dropdown-verfied-profile"
            }
            overlay={<ProfileHeader hide={hideDrop} open={dropVisible} setBillingLoading={setBillingLoading}/>}
            onOpenChange={() => handleVisibleChange(!dropVisible)}
            placement="bottomRight"
            trigger={["click"]}
            open={dropVisible}
            // disabled={userProfile1?.Profiles?.FirstName ==null && userProfile1?.Profiles?.LastName ==null}
            disabled={finishProf ? false : true}
            arrow
          >
            {imageURL && imageURL?.split("/")?.pop() !== "no-pic.png" ? (
              <div className="Avat1">
                <img
                  src={`${process.env.REACT_APP_S3_URL}${
                    imageURL?.charAt(0) !== "/" ? "/" : ""
                  }${imageURL}`}
                  alt=""
                  style={{
                    minWidth: "100%",
                    minHeight: "100%",
                  }}
                />
              </div>
            ) : (
              <div className="profile theAlign">
                <div className="Avat">
                  { getCompanyName(props?.firstUser?.profile) ? getCompanyName(props?.firstUser?.profile).charAt(0) : userProfile1?.UserName?.charAt(0).toUpperCase()||"C"}
                </div>
              </div>
            )}
          </Dropdown>
        )}

        <Drawer
          title={titleDrawerlogin}
          placement="left"
          closable={false}
          onClose={onCloses}
          visible={visibles}
          key={placements}
          className="burgerMenuDrawerMobileView"
        >
          <div className="clickSkillListinglogin" onClick={joinUser}>
            Join SkillGigs
          </div>
          <br></br>
          <div className="Mob_Btn">
            <span className="signIN" onClick={signInUser}>
              Sign in
            </span>
            <br></br>
            <span className="General_btn">General</span>
            <div className="Line-109"></div>
            <span
              className="homeBtn"
              // onClick={homepage}
            >
              <a href="https://skillgigs.com/">Home</a>
            </span>
          </div>
        </Drawer>
      </div>
      {window.innerWidth < 769 && (showSearchBar || !authToken) && (
        <nav
          // className="searchHeaderMobileView"

          className={
            authToken && loggedInSearchBar
              ? "searchHeaderMobileView searchHeaderMobileViewLoggedIn"
              : "searchHeaderMobileView"
          }
          style={{
            padding:
              authToken && loggedInSearchBar && window.innerWidth < 786
                ? "0px 15px"
                : "9px 15px",
          }}
          // aria-details={(!userProfile1?.verification?.email && finishProf) && "extra-top"}
        >
          {/* <SearchBar /> */}

          <SearchBar
            loggedInSearchBar={loggedInSearchBar}
            setloggedInSearchBar={setloggedInSearchBar}
          />
        </nav>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.profileReducer.user.name,
    profileImg: state.profileReducer.user.profile,
    firstUser: state.profileReducer.user,
    error: state.profileReducer.error,
    isModalVisibleAuth: state.authReducer.isModalVisibleAuth,
    authToken: state.authReducer.user.authToken,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    profileDetails: (token) => {
      dispatch(fetchUserProfile(token)); // action dispatched
    },
    setIsModalVisibleAuth: (params) => {
      dispatch(isModalVisibleAuth(params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
